import React, { useState } from 'react';
import Navigation from './Navigation';

const AddProductPage = ({ 
  currentUser, 
  currentPage, 
  setCurrentPage, 
  cart, 
  categories, 
  logout, 
  addProduct 
}) => {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [category, setCategory] = useState('');
  const [price, setPrice] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = () => {
    // Validation
    if (!title.trim()) {
      setError('Product title is required');
      return;
    }
    if (!description.trim()) {
      setError('Product description is required');
      return;
    }
    if (!category) {
      setError('Please select a category');
      return;
    }
    if (!price || parseFloat(price) <= 0) {
      setError('Please enter a valid price greater than 0');
      return;
    }

    // Clear error and submit
    setError('');
    addProduct({ 
      title: title.trim(), 
      description: description.trim(), 
      category, 
      price: parseFloat(price) 
    });
    
    // Reset form
    setTitle('');
    setDescription('');
    setCategory('');
    setPrice('');
  };

  return (
    <div className="container">
      <div className="header">
        <h1>🌱 EcoFinds</h1>
        <Navigation 
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          cart={cart}
          logout={logout}
        />
      </div>
      
      <div className="form">
        <h2>Add New Product Listing</h2>
        {error && <div className="error">{error}</div>}
        
        <input
          type="text"
          placeholder="Product Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          maxLength="100"
        />
        
        <select value={category} onChange={(e) => setCategory(e.target.value)}>
          <option value="">Select Category</option>
          {categories.map(cat => (
            <option key={cat} value={cat}>{cat}</option>
          ))}
        </select>
        
        <textarea
          placeholder="Product Description (detailed information about condition, features, etc.)"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          rows="5"
          maxLength="500"
        />
        
        <input
          type="number"
          step="0.01"
          min="0.01"
          placeholder="Price in USD"
          value={price}
          onChange={(e) => setPrice(e.target.value)}
        />
        
        <div style={{
          padding: '30px', 
          background: '#f9f9f9', 
          textAlign: 'center', 
          margin: '15px 0',
          border: '2px dashed #ccc',
          borderRadius: '8px'
        }}>
          <div style={{fontSize: '24px', marginBottom: '10px'}}>📷</div>
          <p>Image Upload (Placeholder)</p>
          <p style={{fontSize: '12px', color: '#666'}}>Click to upload product images</p>
        </div>
        
        <button onClick={handleSubmit}>
          Create Listing
        </button>
        
        <button onClick={() => setCurrentPage('browse')} style={{background: '#666'}}>
          Cancel
        </button>
      </div>
    </div>
  );
};

export default AddProductPage;